jQuery(document).ready(function ($) {
    $.fn.toggleDiningMenu = function () {
        if (this.hasClass('selected')) {
            return this;
        }

        const menu = this.attr('data-menu');

        this.siblings().removeClass('selected');
        this.addClass('selected');

        this.parent().next().find('.dining-menus__menu').hide();
        this.parent().next().find(`.dining-menus__menu[data-menu="${menu}"]`).show();

        $('.notice').adjustHeight();

        return this;
    }

    $('.dining-menus__tab').on('click', function (event) {
        event.preventDefault();

        $(this).toggleDiningMenu();
    });
});